import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { Home } from "@/features/my/home";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  // Lenient, read by `memberComponentRefOf`: with both, a component of the member's home opens over the page
  // (`/my/home?placeId=<home>&component=<node key>`, the page the platform writes for it).
  placeId: z.string().optional(),
  component: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(protected)/my/home")({
  validateSearch: searchSchema,
  component: Home,
});
